// extracted by mini-css-extract-plugin
export default {"container":"swSBgvnHOVjnBMw22ZIm","fullScreenContainer":"ucB3RkYXFw3qmzEXsva5"};